export function initBurgerMenu() {
    const burgerButton = document.querySelector('.burger-menu');
    const burgerContainer = document.querySelector('.burger-menu-container');
    const body = document.body;

    // Create overlay element
    const overlay = document.createElement('div');
    overlay.className = 'overlay';
    body.appendChild(overlay);

    function toggleMenu() {
        burgerButton.classList.toggle('active');
        burgerContainer.classList.toggle('open');
        overlay.classList.toggle('active');
        body.style.overflow = burgerContainer.classList.contains('open') ? 'hidden' : '';
    }

    function closeMenu() {
        burgerButton.classList.remove('active');
        burgerContainer.classList.remove('open');
        overlay.classList.remove('active');
        body.style.overflow = '';
    }

    // Toggle menu on button click
    burgerButton.addEventListener('click', toggleMenu);

    // Close menu when clicking overlay
    overlay.addEventListener('click', closeMenu);

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && burgerContainer.classList.contains('open')) {
            closeMenu();
        }
    });

    // Close menu when clicking a nav link (optional)
    const navLinks = burgerContainer.querySelectorAll('nav a');
    navLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Close menu on window resize to desktop size
    window.addEventListener('resize', () => {
        if (window.innerWidth > 768 && burgerContainer.classList.contains('open')) {
            closeMenu();
        }
    });
}